<template lang="pug">
.image-gallery
  .modal
    .modal-content
      .header
        span.property {{ property.name }}
        span.close(@click='closeModal') &times;
      .container
        .row.d-flex.justify-content-center.images(v-if="!isEmpty(property.images)")
          .col-md-3.wrapper-list
            .list
              ul
                li(
                  v-for="(image, index) in property.images"
                  :class="{ selected: index === activeImageIndex }"
                  @click='activeImage(index)'
                )
                  img(:src='image.url')
          .col-md-8
            .preview
              img(:src='currentImage')
        .row.d-flex.justify-content-center.no-images(v-else)
          p {{ $t('image_gallery.no_images') }}
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      activeImageIndex: 0
    }
  },

  computed: {
    currentImage() {
      return this.property.images[this.activeImageIndex].url
    },
  },

  methods: {
    isEmpty,

    activeImage(index) {
      this.activeImageIndex = index
    },

    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-gallery {
  .modal {
    background-color: #3f4a56;
    display: block;
    height: 100%;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;

    .modal-content {
      background-color: transparent;
      box-shadow: none;
      margin: 2% auto;
      padding: 20px;
      width: 98%;

      .preview {
        span {
          color: #fff;
          position: absolute;
          top: 50%;
        }

        .next {
          left: 96%;
          margin-left: 6px;
        }

        img {
          height: 100%;
          width: 100%;
        }
      }

      .wrapper-list {
        max-width: 120px;
        padding: 0;

        .list {
          height: 538px;
          margin: 5px;
          overflow-y: auto;

          ul {
            list-style-type: none;
            margin: 0;
            padding: 0;

            li {
              height: 95px;
              margin-bottom: 10px;

              img {
                height: 100%;
                width: 100%;
              }
            }

            .selected {
              border: 3px solid #d8d8d8;
            }
          }
        }
      }

      .images {
        margin-top: 100px;
      }

      .no-images {
        color: #fff;
        font-size: 18px;
        margin-top: 20%;
      }
    }

    .header {
      .property {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
      }

      .close {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
      }

      .close:hover,
      .close:focus {
        color: black;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
</style>
